import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import "../EPRQuestions/EPRCarousel/index.css";
import { Typography } from "@mui/material";
import "./index.css";
import { useTranslation } from "react-i18next";

export default function EPRAccountingYears({
  accountingYears,
  setChosenYear,
  setYearEcoApi,
  setAccountingPeriod,
  setAllocatedYear,
  yearOptions,
  accountingPeriod,
}) {
  const { t } = useTranslation();
  return (
    <div
      className="card-interactive-carousel-active"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "fit-content",
        paddingBottom: "50px",
      }}
    >
      <Typography
        sx={{
          color: "white",
          textAlign: "center",
          marginBottom: "16px",
        }}
      >
        {t("SELECT_YEAR")}
      </Typography>
      <div
        className="accounting-year-container"
        style={{
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
          marginBottom: "4px",
        }}
      >
        <div className="accounting-year-label" style={{ padding: "0 24px" }}>
          {t("ACCOUNTING_YEAR")}
        </div>
        <Autocomplete
          disablePortal={false}
          options={accountingYears}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                border: "none",
              },
              "&:hover fieldset": {
                border: "none",
              },
              "&.Mui-focused fieldset": {
                border: "none",
              },
              "& .MuiAutocomplete-popupIndicator": {
                color: "#09366B",
              },
              "& .MuiAutocomplete-input": {
                color: "#09366B",
                textAlign: "center",
              },
            },
            width: 300,
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={t("ACCOUNTING_YEAR")}
              InputProps={{
                ...params.InputProps,
                sx: {
                  "&:before": {
                    borderBottom: "none",
                  },
                  "&:after": {
                    borderBottom: "none",
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: "#09366B",
                  "&.Mui-focused": {
                    color: "#09366B",
                  },
                },
              }}
            />
          )}
          onChange={(e, val) => {
            if (val) {
              setChosenYear(val.year);
              if (val.totals && typeof val.totals === "string") {
                const parts = val.totals.split("/");
                const accountingYear = parts[parts.length - 2];
                setYearEcoApi(accountingYear);
              }

              const fromDate = val.fromDate;
              const toDate = val.toDate;
              const period = `${fromDate} - ${toDate}`;
              setAccountingPeriod(period);
            }
          }}
        />
      </div>
      <div
        className="accounting-year-container"
        style={{
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
          marginBottom: "4px",
        }}
      >
        <div className="accounting-year-label" style={{ padding: "16px 15px" }}>
          {t("ACCOUNTING_PERIOD")}
        </div>
        <div
          style={{
            width: "300px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {accountingPeriod}
        </div>
      </div>

      <div
        className="accounting-year-container"
        style={{
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        <div className="accounting-year-label"> {t("ALLOCATE_YFS_YEAR")}</div>
        <Autocomplete
          disablePortal={false}
          options={yearOptions}
          onChange={(e, val) => {
            if (val) {
              setAllocatedYear(val);
            }
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                border: "none",
              },
              "&:hover fieldset": {
                border: "none",
              },
              "&.Mui-focused fieldset": {
                border: "none",
              },
              "& .MuiAutocomplete-popupIndicator": {
                color: "#09366B",
              },
              "& .MuiAutocomplete-input": {
                color: "#09366B",
                textAlign: "center",
              },
            },
            width: 300,
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="YFS Allocated Years"
              InputProps={{
                ...params.InputProps,
                sx: {
                  "&:before": {
                    borderBottom: "none",
                  },
                  "&:after": {
                    borderBottom: "none",
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: "#09366B",
                  "&.Mui-focused": {
                    color: "#09366B",
                  },
                },
              }}
            />
          )}
        />
      </div>
    </div>
  );
}
